import FactorBlock from "../FactorBlock.vue";
import { BaseFactorState } from "../../BaseFactorState";
import InitState from "./InitState";
import NodesSelectionState from "./NodesSelectionState";

/** Sélection des noeuds cochés (qui génère donc une 'Pin') */
export default class CheckedSelectionState extends BaseFactorState<FactorBlock> {
    public constructor() {
		super();
	}
    
    /** Sur l'entrée dans l'état
    * @param args Paramètres optionnels
    */
    public Enter(args?: any): void {
        console.debug("CheckedSelectionState - Enter - args :", args);
        this.context.FactorNodesVisible = true;
    }

    /** Sur sortie de l'état sur application
    * @param args Paramètres optionnels 
	**/
    public Next(args?: any): void {
        console.debug("CheckedSelectionState - Next - args : ", args);

        /** Passage dans le args de :
         *   - this.context.CheckedNodesIds = args["checkedNodeIds"];
         *   - this.context.SelectedNode = args["selectionNode"];
         * Ces variables sont alimentées dans l'Enter() du NodesSelectionState avant l'affichage de FactorSelectionNode
         */

        this.context.TransitionTo(new NodesSelectionState(), args);
    }

    /** Sur fermeture d'un état */
    public Previous(args?: any): void {
        console.debug("CheckedSelectionState - Previous : ", args);
        this.context.FactorNodesVisible = false;
        this.context.TransitionTo(new InitState());
    }    
}